import React from 'react';
import Spinner from '@xo-union/tk-component-spinner';
import styles from './index.scss';

const Loader: React.FC = () => (
  <div className={styles.loadingContainer} data-testid="loading-spinner">
    <Spinner className={styles.spinner} />
  </div>
);

export default Loader;
